module.exports = __webpack_public_path__ + "static/HKGrotesk-Italic-a12eb7054ee38a8c331276389db07cc7.ttf";